// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAN5TgXDgaSeW1u3XlN16G097P0ly4Db6Y",
  authDomain: "menuscanner-6f332.firebaseapp.com",
  projectId: "menuscanner-6f332",
  storageBucket: "menuscanner-6f332.firebasestorage.app",
  messagingSenderId: "900061990435",
  appId: "1:900061990435:web:507b2f140ffa1f2491ab96",
  measurementId: "G-M04V0HHX3V",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app);

// Export the initialized app and services
export { app, analytics, storage };
export default app;
